import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const FORM = {
  why: [["title", "Título", "input"], ["body", "Cómo sí", "area"], ["dudas", "Dudas reales", "area"], ["source", "Fundamento legal", "input"], ["url_contenido", "Enlace del video (https://…)", "input"]],
  faq: [["pregunta", "Pregunta", "input"], ["respuesta", "Respuesta", "area"], ["categoria", "Categoría", "input"], ["fuente", "Fuente", "input"], ["url_contenido", "Enlace del video (https://…)", "input"]],
};

const Field = ({ k, label, type, value, onChange }) => (
  <label className="block text-sm font-semibold text-slate-700">
    {label}
    {type === "area" ? (
      <textarea rows={6} value={value || ""} onChange={(e) => onChange(k, e.target.value)} data-testid={`entry-${k}`}
        className="mt-1 w-full rounded-lg border border-[#CBD5E1] p-2 text-sm font-normal" />
    ) : (
      <input value={value || ""} onChange={(e) => onChange(k, e.target.value)} data-testid={`entry-${k}`}
        className="mt-1 w-full h-10 rounded-lg border border-[#CBD5E1] px-2 text-sm font-normal" />
    )}
  </label>
);

export const EntryDialog = ({ kind, meta, entry, open, onClose, onSaved }) => {
  const [f, setF] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (open) { setF(entry ? { ...entry, fields: (entry.fields || []).join(", ") } : { jurisdiccion: "Nacional" }); }
  }, [open, entry]);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const save = async () => {
    setSaving(true);
    const payload = { ...f, fields: kind === "why" ? String(f.fields || "").split(",").map((s) => s.trim()).filter(Boolean) : undefined };
    try {
      const { data } = entry
        ? await api.put(`/copiloto/${kind}/${encodeURIComponent(entry.id)}`, payload)
        : await api.post(`/copiloto/${kind}`, payload);
      onSaved(data, !entry);
      toast.success(entry && entry.estado !== "borrador_ia" ? "Guardado. Vuelve a revisión." : "Guardado");
      onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "No se pudo guardar"); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="entry-dialog">
        <DialogHeader><DialogTitle>{entry ? "Editar entrada" : "Nueva entrada"}</DialogTitle></DialogHeader>
        {entry?.estado === "publicado" && (
          <p className="text-xs text-[#92400E] bg-[#FFFBEB] rounded-lg p-2">Los asesores seguirán viendo la versión publicada hasta que vuelvas a aprobar y publicar.</p>
        )}
        <div className="space-y-3">
          {kind === "why" && !entry && (
            <>
              <label className="block text-sm font-semibold text-slate-700">Documento
                <Select value={f.document || ""} onValueChange={(v) => set("document", v)}>
                  <SelectTrigger className="mt-1" data-testid="entry-document"><SelectValue placeholder="Elige contrato" /></SelectTrigger>
                  <SelectContent>{Object.entries(meta.documentos).map(([k, n]) => <SelectItem key={k} value={k}>{n}</SelectItem>)}</SelectContent>
                </Select>
              </label>
              <Field k="fields" label="Campo(s) del cuestionario, separados por coma" type="input" value={f.fields} onChange={set} />
            </>
          )}
          <label className="block text-sm font-semibold text-slate-700">Jurisdicción
            <Select value={f.jurisdiccion || "Nacional"} onValueChange={(v) => set("jurisdiccion", v)}>
              <SelectTrigger className="mt-1" data-testid="entry-jurisdiccion"><SelectValue /></SelectTrigger>
              <SelectContent>{meta.jurisdicciones.map((j) => <SelectItem key={j} value={j}>{j}</SelectItem>)}</SelectContent>
            </Select>
          </label>
          {FORM[kind].map(([k, label, type]) => <Field key={k} k={k} label={label} type={type} value={f[k]} onChange={set} />)}
        </div>
        <DialogFooter>
          <Button onClick={save} disabled={saving} className="bg-[#1E3A5F] hover:bg-[#16304F]" data-testid="entry-save">Guardar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
